// @ts-check

/* eslint-disable react/no-array-index-key */
import React from "react";
import { Link } from "gatsby";

import ArticleContainer from "../ArticleContainer";
import ArticleHeaderContainer from "../ArticleHeaderContainer";
import Header from "../../../components/Header";
import DateLabel from "../../../components/DateLabel";
import ImgContainer from "../../../components/ImgContainer";

function FeedSection({ slug, title, date, image, alt, description }) {
  return (
    <ArticleContainer
      isPreview
      hasShadow
      hasRelativePosition={false}
      isFlexCol
      Component="article"
    >
      <ArticleHeaderContainer>
        <div className="pb-1 md:pb-2">
          <Link to={slug}>
            <Header isHover type="linkedPreviewBig" title={title} />
          </Link>
        </div>
        {date && <DateLabel isLarge hasFullOpts={false} date={date} />}
      </ArticleHeaderContainer>

      <ImgContainer
        imgClassName="h-32 md:h-56"
        type="feedPreview"
        slug={slug}
        image={image}
        alt={alt}
        caption={null}
      >
        <div className="my-3 md:my-5 md:font-medium text-lg leading-normal md:leading-relaxed">
          {description}
        </div>
      </ImgContainer>
    </ArticleContainer>
  );
}

function Feed({ edges }) {
  return (
    <div>
      {edges.map(
        ({
          node: {
            slug,
            title,
            description,
            createdAt: date,
            publish_at: publishAt,
            cover,
          },
        }) => {
          return (
            <FeedSection
              slug={slug}
              title={title}
              date={publishAt || date}
              image={cover}
              alt={cover.alterativeText}
              description={description}
              key={slug}
            />
          );
        }
      )}
    </div>
  );
}

export default Feed;
